// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_vSZIT clearfix","box_r":"index_box_r_48Jxm","d_box":"index_d_box_1mbQF"};